import AutoSuggest from "react-autosuggest";
import * as React from "react";
import { PropsType } from "../../containers/SearchBoxContainer";
import {
  Input,
  InputGroup,
  InputGroupAddon
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faTimes } from "@fortawesome/free-solid-svg-icons";
import "./SearchBox.scss";
import i18next from 'i18next';

interface State {
  searchInput: string;
  isDirty: boolean
};

class SearchBox extends React.Component<PropsType, State> {
  constructor(props: PropsType) {
    super(props);
    this.state = { searchInput: "", isDirty: false };
  }

  private searchRef = React.createRef<HTMLInputElement>();
  private autosuggestRef = React.createRef<AutoSuggest>();

  componentDidMount() {
    this.searchRef.current!.focus();
  }

  onInputChange(
    changeEvent: React.ChangeEvent<HTMLInputElement>,
    newValue: any
  ) {
    if (newValue.method === "up" || newValue.method === "down") {
      return;
    }
    const input = newValue.newValue;
    this.setState({ searchInput: input });
    // First part of replace removes special characters from search string 
    // UX wants to have a leading wildcard for every entered word...
    this.props.onInputChange(`/.*${input.replace(/[-–<>!&"'@\/[\]{}()*+?.:;,\\^$|#\s]/g, ' ').replace(/ /g, ".*/&&/.*")}.*/`);
    if (newValue.method === "click" || newValue.method === "enter") {
      this.props.commenceSearch();
    }
    this.setState({isDirty: true});
  }
  handleKeyDown(evt: any) {
    if (evt.key === "Enter" && this.state.isDirty) {
      this.setState({isDirty: false});
      return this.props.commenceSearch();
    }
  }
  getSuggestionValue(suggestion: any) {
    return suggestion.title;
  }
  clearInput() {
    let currentSearchValue = (this.searchRef.current) ? this.searchRef.current!.value : "";
    if (currentSearchValue != "") {
      this.props.onInputChange("");
      this.setState({ searchInput: "" });
      this.props.commenceSearch();
      this.searchRef.current!.value = "";
    }
  }

  /** Gets the search icon classes according to the current component's state */
  getSearchIconClasses() {
    let classesList = new Array();
    classesList.push("input-group-text");

    if (this.state.searchInput != "")
      classesList.push("active");

    return classesList.join(" ");
  }

  handleSearchIconClick(){
    if(this.state.searchInput !== "") {
      this.props.commenceSearch()
    }
  }

  renderInputComponent(inputProps: any) {
    return (
      <div>
        <InputGroup className="has-feedback">
          <Input {...inputProps} innerRef={this.searchRef} />
          {this.searchRef.current && this.searchRef.current!.value ? (
            <FontAwesomeIcon
              className="clear-field"
              icon={faTimes}
              onClick={() => {
                this.clearInput();
              }}
            />
          ) : (
              ""
            )}
            <InputGroupAddon addonType="append">
            <span className={this.getSearchIconClasses()} onClick={() => this.handleSearchIconClick()}>
              <FontAwesomeIcon icon={faSearch} />
            </span>
          </InputGroupAddon>
        </InputGroup>
      </div>
    );
  }
  renderSuggestion(suggestion: any) {
    return <div dangerouslySetInnerHTML={{ __html: suggestion.title }} />;
  }
  render() {
    const {
      input,
      onInputChange,
      suggestions,
      suggest,
      clearSuggestions,
      postTag,
      preTag,
      commenceSearch
    } = this.props;

    // input props

      const inputProps = {
      placeholder: i18next.t('Search'),
      value: this.state.searchInput,
      onChange: this.onInputChange.bind(this),
      type: "text",
      onKeyPress: this.handleKeyDown.bind(this)
    };
    return (
      <div className="header-searchbox" id="searchBox">
        <AutoSuggest
          suggestions={suggestions}
          onSuggestionsFetchRequested={() => {
            return null;
          }}
          onSuggestionsClearRequested={clearSuggestions}
          //onSuggestionSelected={clearFacetsAndSearch(input)}
          inputProps={inputProps}
          getSuggestionValue={this.getSuggestionValue.bind(this)}
          renderInputComponent={this.renderInputComponent.bind(this)}
          renderSuggestion={this.renderSuggestion.bind(this)}
          ref={this.autosuggestRef}
        />
      </div>
    );
  }
}

export default SearchBox;
